import { useState, useEffect } from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.div`
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: ${props => (props.isVisible ? 'translateY(0)' : 'translateY(28px)')};
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: opacity, transform;
`;

export default function ScrollReveal({ children, threshold = 0.15, className = '', id = '' }) {
  const [isVisible, setIsVisible] = useState(false);
  const [domRef, setDomRef] = useState(null);

  useEffect(() => {
    // If reduced motion is preferred, reveal immediately
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setIsVisible(true);
      return;
    }

    if (!domRef) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(domRef);
    return () => observer.disconnect();
  }, [domRef, threshold]);

  return (
    <SectionWrapper ref={setDomRef} isVisible={isVisible} className={className} id={id}>
      {children}
    </SectionWrapper>
  );
}
